function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import ReactSlider from 'react-slider';
import Input from '../input';
import Row from '../row';
import styles from './styles.module.scss';

var Slider = function Slider(_ref) {
  var min = _ref.min,
      max = _ref.max,
      singleSlider = _ref.singleSlider;

  var _useState = useState([min, max]),
      _useState2 = _slicedToArray(_useState, 2),
      range = _useState2[0],
      setRange = _useState2[1];

  var _useState3 = useState(min),
      _useState4 = _slicedToArray(_useState3, 2),
      low = _useState4[0],
      setLow = _useState4[1];

  var _useState5 = useState(max),
      _useState6 = _slicedToArray(_useState5, 2),
      high = _useState6[0],
      setHigh = _useState6[1];

  var onLowerBlur = function onLowerBlur(e) {
    var value = parseInt(e.target.value) || 0;
    var newMin = !inRange(value, range) ? min : value;
    setRange([newMin, range[1]]);
    setLow(newMin);
  };

  var onUpperBlur = function onUpperBlur(e) {
    var value = parseInt(e.target.value) || 0;
    var newMax = !inRange(value, range) ? max : value;
    setRange([range[0], newMax]);
    setHigh(newMax);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: styles.inputRow
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.currencyInput
  }, /*#__PURE__*/React.createElement(Input, {
    "data-testid": "min",
    onBlur: onLowerBlur,
    type: "number",
    className: styles.input,
    sizing: "lg",
    value: low,
    onChange: function onChange(e) {
      var value = e.target.value;
      setLow(value);
    }
  }), /*#__PURE__*/React.createElement("i", {
    className: styles.icon
  }, "$")), /*#__PURE__*/React.createElement("span", {
    className: styles.inputDivider
  }, "\u2212"), /*#__PURE__*/React.createElement("div", {
    className: styles.currencyInput
  }, /*#__PURE__*/React.createElement(Input, {
    "data-testid": "max",
    onBlur: onUpperBlur,
    type: "number",
    className: styles.input,
    sizing: "lg",
    value: high,
    onChange: function onChange(e) {
      var value = e.target.value;
      setHigh(value);
    }
  }), /*#__PURE__*/React.createElement("i", {
    className: styles.icon
  }, "$"))), /*#__PURE__*/React.createElement(ReactSlider, {
    className: styles.slider,
    thumbClassName: styles.thumb,
    trackClassName: styles.track,
    defaultValue: singleSlider ? undefined : [min, max],
    min: min,
    max: max,
    value: singleSlider ? undefined : range,
    step: 1,
    ariaLabel: ['Lower thumb', 'Upper thumb'],
    ariaValuetext: function ariaValuetext(state) {
      return "Thumb value ".concat(state.valueNow);
    },
    pearling: true,
    onChange: function onChange(value) {
      if (value && Array.isArray(value)) {
        setLow(value[0]);
        setHigh(value[1]);
        setRange(value);
      }
    }
  }));
};

export var inRange = function inRange(x, range) {
  return (x - range[0]) * (x - range[1]) <= 0;
};
export default Slider;